// extracted by mini-css-extract-plugin
module.exports = {"approveTrainingModel":"style_approveTrainingModel__3GlLl"};